import React from 'react';

export default function ErrorBanner({ message, onRetry }) {
  if (!message) return null;
  return (
    <div style={styles.banner}>
      <span style={styles.icon}>⚠️</span>
      <span style={styles.msg}>{message}</span>
      {onRetry && (
        <button onClick={onRetry} style={styles.btn}>Retry</button>
      )}
    </div>
  );
}

const styles = {
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    background: '#fef2f2',
    border: '1px solid #fecaca',
    color: '#dc2626',
    padding: '0.75rem 1rem',
    borderRadius: '0.5rem',
    margin: '1rem 0',
    fontSize: '0.875rem',
  },
  icon: { fontSize: '1rem', flexShrink: 0 },
  msg: { flex: 1 },
  btn: {
    background: '#dc2626',
    color: '#fff',
    border: 'none',
    borderRadius: '0.375rem',
    padding: '0.25rem 0.75rem',
    cursor: 'pointer',
    fontSize: '0.8rem',
    fontWeight: '600',
  },
};
